import {Plus} from "lucide-react";
import React, {useState} from "react";
import {SessionData, SessionModal} from "./SessionModal";
import {useApiClient} from "../../../base/hooks/useApiClient";
import {useNavigate} from "react-router-dom";

export function CreateSessionButton() {
    const apiClient = useApiClient();
    const navigate = useNavigate();
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

    const handleCreateSession = async (sessionData: SessionData) => {
        const { name, originalLanguage, translationLanguages } = sessionData;

        const response = await apiClient.post('sessions', {
            name,
            originalLanguage,
            translationLanguages,
        });

        if (!response.ok) {
            return;
        }

        const { sessionUuid } = await response.json();
        navigate(`/panel/sessions/${sessionUuid}`);
        setIsCreateModalOpen(false);
    };

    return (
        <>
            <button
                onClick={() => setIsCreateModalOpen(true)}
                className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
            >
                <Plus className="h-5 w-5 mr-2" />
                New Session
            </button>

            <SessionModal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                onSubmit={handleCreateSession}
            />
        </>
    );
}
